import request from '../../utils/request';
import { stringify } from 'qs';

export async function getAppCategory(params) {
  return request(`/api/blade-system/app-category/page?${stringify(params)}`);
}

export async function getApps(params) {
  return request(`/api/blade-system/app/categoryAppList/h5`);
}

export async function getCmsAppInfo(params) {
  return request(`/api/tscloud-cms/app-cms/detailByCode?${stringify(params)}`);
}

export async function getNavs(params) {
  return request(`/api/tscloud-cms/app-nav/list?${stringify(params)}`);
}

export async function getCmpts(params) {
  return request(`/api/tscloud-cms/module-cmpt/list?${stringify(params)}`);
}

export async function detail(params) {
  return request(`/api/blade-system/app/detail?${stringify(params)}`);
}
